import MainLayout from '../layouts/main';
import TermsAndConditions from './terms-and-conditions';

function TermsAndConditionsPage() {
  return (
    <MainLayout loginRequired={false} consultPackageRequired={false} packageRequired={false}>
      <TermsAndConditions />
    </MainLayout>
  );
}

export default TermsAndConditionsPage;
